<template>
  <span :class="iconClass">
    <FontAwesomeIcon
      :icon="icon"
      :class="{ 'fa-spin': status === 'in_progress' }"
    />
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import type { CompanyStatus } from "../composables/useBulkIssuance";

const props = defineProps<{
  status: CompanyStatus;
}>();

const icon = computed(() => {
  switch (props.status) {
    case "pending":
      return "clock";
    case "in_progress":
      return "spinner";
    case "completed":
      return "check-circle";
    case "skipped":
      return "forward";
    case "error":
      return "times-circle";
    default:
      return "question-circle";
  }
});

const iconClass = computed(() => {
  switch (props.status) {
    case "completed":
      return "text-success";
    case "skipped":
      return "text-muted";
    case "error":
      return "text-danger";
    case "in_progress":
      return "text-primary";
    default:
      return "text-secondary";
  }
});
</script>
